/** チェーン登録画面の画面名定数。getWordList に渡す画面識別子。 */
export const CHAIN_REGISTER_FILE_NAME = "ChainRegister";

/** vee-validate Field の name 属性で使用される必須ラベルキー。wordList 準備判定に使用。 */
export const REQUIRED_FIELD_LABEL_KEYS = [
  'lbl_chain_code',
  'lbl_chain_name',
  'lbl_house_card_display',
  'lbl_house_card_required',
  'lbl_house_card_digit',
  'lbl_house_card_format',
  'lbl_operator_column_email',
  'lbl_dss_connection_name',
  'lbl_dss_chain_store_code',
  'lbl_dss_api_base_url',
  'lbl_access_key',
  'lbl_secret_key',
] as const;
